import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserOrganisationUniqueData {
  users: []
}

export function useUserOrganisationUsers() {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userOrganisationUsers'],
    queryFn: async (): Promise<UserOrganisationUniqueData> => {
      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/get_organisation_users`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      const { users } = data?.data;

      return {
        users
      };
    }
  });
}